<template>
  <div class="max-w-7xl mx-auto py-2  px-2 ">
    <div class="md:grid">
      <div class="py-4">
        <span class="text-lg">Novo acompanhante</span>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white">
            <div class="grid grid-cols-6 gap-6 py-2">
              <div class="col-span-12">
                <form @submit.prevent="save">
                  <div class="col-span-12 px-2 space-y-4">

                    <div class="col-span-12 sm:col-span-4">
                      <label class="block font-medium text-sm text-gray-700">
                        Usuário
                      </label>
                      <select-autocomplete
                        class="mt-1"
                        placeholder="usuário"
                        :object-return="false"
                        primary-key="id"
                        label="name"
                        :multiple="false"
                        v-model="form.user_id"
                        :url-search="route('api.select.user')"
                      >
                        <span slot-scope="{ item }">
                          <div>

                            <span> {{ item.name }}</span>
                            <span class="text-gray-500 text-xs"> {{ item.email }}</span>
                          </div>
                        </span>
                      </select-autocomplete>
                      <jet-input-error
                        :message="form.errors.user_id"
                        class="mt-2"
                      />
                    </div>

                    <div class="col-span-12 flex justify-around">
                      <div class="flex flex-row-reverse space-x-28 space-x-reverse px-4  py-4 sm:py-6">
                        <button-primary
                          :class="{ 'opacity-25': form.processing }"
                          :disabled="form.processing"
                        > Salvar
                        </button-primary>
                        <button-secondary @click.native="$emit('close')">
                          Cancelar
                        </button-secondary>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import SelectAutocomplete from "@/Components/SelectAutocomplete";
export default {
  name: 'CentroCustoAcompanhanteCreate',
  props: ['centroCustoId'],
  components: {
    AppLayout,
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    ButtonPrimary,
    ButtonSecondary,
    SelectAutocomplete
  },
  data() {
    return {
      errors: {},
      form: this.$inertia.form({
        centro_custo_id: this.centroCustoId,
        user_id: null
      },
        {
          bag: 'createResponsavel'
        }),
    }
  },
  methods: {

    save() {
      this.form.post(route('centro-custo-acompanhantes.store'), {
        preserveScroll: true,
        onSuccess: () => this.$emit('close')
      });
    },

  }
}
</script>


<style scoped>
</style>
